import { Container, Graphics, Rectangle } from "pixi.js"
import { SCALER } from "../../../../client_util"
import { createButton } from "./button_factory"
import { UiButton } from "./ui_button"

export type MobileBuildTool = "single" | "line" | "room"
export interface MobileBuildState {
    available: boolean
    active: boolean
    tool: MobileBuildTool
    canUndo: boolean
    material: string
}

/** A mobile-only dock; the normal desktop palette never uses this layout. */
export class MobileBuildToolbar extends Container {
    private panel = new Container()
    private enter: UiButton
    private tools = new Map<MobileBuildTool, UiButton>()
    private undo: UiButton
    private signature = ""

    constructor(actions: { toggle: (on: boolean) => void; select: (tool: MobileBuildTool) => void;
        undo: () => void }) {
        super()
        this.scale.y = 1 / SCALER
        this.zIndex = 60003
        this.enter = createButton({ label: "Build", width: 90, height: 42, hitPadding: 0,
            onClick: () => actions.toggle(true) })
        this.addChild(this.enter, this.panel)
        const background = new Graphics().beginFill(0x20262d, 0.97).drawRoundedRect(0, 0, 296, 62, 10).endFill()
        this.panel.interactive = true
        this.panel.hitArea = new Rectangle(0, 0, 296, 62)
        this.panel.addChild(background)
        ;(["single", "line", "room"] as MobileBuildTool[]).forEach((tool, index) => {
            const button = createButton({ label: tool[0].toUpperCase() + tool.slice(1), width: 66, height: 42,
                hitPadding: 0, onClick: () => actions.select(tool) })
            button.position.set(10 + index * 70, 10)
            this.tools.set(tool, button)
            this.panel.addChild(button)
        })
        this.undo = createButton({ label: "Undo", width: 66, height: 42, hitPadding: 0, onClick: actions.undo })
        this.undo.position.set(220, 10)
        this.panel.addChild(this.undo)

    }

    update = (state: MobileBuildState, readiedBar: { x: number; y: number }) => {
        this.visible = state.available || state.active
        this.panel.visible = state.active
        this.enter.visible = !state.active
        // The tray shares our parent; compensate for our vertical scale to keep an 8-unit gap.
        const aboveTray = (readiedBar.y - 8) * SCALER
        this.panel.position.set(readiedBar.x, aboveTray - 62)
        this.enter.position.set(readiedBar.x, aboveTray - 42)
        const signature = `${state.tool}:${state.canUndo}`
        if (signature !== this.signature) {
            this.signature = signature
            this.tools.forEach((button, tool) => button.setSelected(tool === state.tool))
            this.undo.setEnabled(state.canUndo)
        }
    }
}
